import { configureStore } from "@reduxjs/toolkit";
import initialDataReduces from "./initialDataSlice";
import pageSliceReducer from "./PageSlice";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import { combineReducers } from "redux";
import redRes from "./../DCM/components/Reducer/redRes";
import redRes1 from "./../DCM/components/Reducer/redRes1";
import redRes2 from "./../DCM/components/Reducer/redRes2";
import { osmReducer } from "../osm/redux";

// ---- 1. Combine ALL reducers FIRST ----
const rootReducer = combineReducers({
  initialData: initialDataReduces,
  pageSlice: pageSliceReducer,
  redres: redRes,
  redres1: redRes1,
  redres2: redRes2,
  osm: osmReducer,
});

// ---- 2. Persist the whole root, whitelist only osm + initialData + pageSlice ----
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["initialData", "pageSlice", "osm"], // ← top-level slices
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// ---- 3. configureStore gets ONE persisted reducer ----
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // persist's internal actions carry non-serializable values
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
